import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CharacterCoreService } from './character-core.service';
import { CharacterSelectorComponent } from './character-selector/character-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [CharacterSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [CharacterCoreService],
  exports: [CharacterSelectorComponent],
})
export class CharacterCoreModule {}
